export class HideImage {
    hideImageSpeaker: boolean = false;
    hideImageOrganizer: boolean = false;
    hideImageSponsor: boolean = false;
    hideImageExhibitor: boolean = false;

}


// WEBPACK FOOTER //
// /app/src/app/core/models/hideImage.ts